import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse, HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";

/**
 * Servicio para usar el Local Storage
 */
import { StorageService } from "../services/storage.service";

/**
 * Servicio común para todos los componentes
 */
import { MainService } from "../services/main.service";

/**
 * Interfaz para estructurar la salida de mensajes
 */
import { AlertMessage } from "../interfaces/alert-message";
import { catchError } from "rxjs/operators";

/**
 * - Clase para inyectar los headers que requieren las llamadas a servicios
 * - Estos header son obtenenidos desde el storage service
 * - Los header son guardados cuando se llaman al servicio [AppLoadService]
 * Este obtiene el token para continuar con las llamadas, así como el [x-auth-token]
 *
 * @author: Isaac Salgado @iiSalgado
 * @version: 13/09/2018
 *
 */
@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  private excludeUrls: string[] = ['https://api2.branch.io/v2/event/custom'];
  /**
   * Referencias a servicios
   */
  constructor(private storageService: StorageService) {}

  /**
   * - Se anexan los header a las peticiones en caso de existir
   * - En caso de error se lanza un mensaje hacia el cliente
   * - En caso de falla al llamar se hacen 3 intentos
   *
   * @param req HttpRequest
   * @param next HttpHandler
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const exclude = this.excludeUrls.some(_url => req.url.includes(_url))
    let headers = {
      "Content-Type": "application/json",
    };

    if (this.storageService.get("CHANNELID")) {
      headers["channelId"] = this.storageService.get("CHANNELID");
    }

    if(exclude) {
      return next.handle(req);
    }

    return next.handle(req.clone({ setHeaders: headers })).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        const error =
          typeof errorResponse !== "object"
            ? JSON.parse(errorResponse)
            : errorResponse;
        if (errorResponse.status === 0) {
          const message: AlertMessage = {
            title: "Atención",
            body: "Revisa tu conexión a internet",
            buttonAccept: "Aceptar",
          };
        }
        //return Observable.throw(error);
        return throwError(null);
      })
    );
    //.retry(3);
  }
}
